import React, { useState, useEffect, DragEvent, useRef } from "react";
import axios from "axios";
import Webcam from "react-webcam";
import * as XLSX from "xlsx";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  IconButton,
  Paper,
  InputAdornment,
  Chip,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Breadcrumbs,
  Link,
  useMediaQuery,
  useTheme,
  Divider,
  Avatar,
  Card,
  CardContent,
  CardActions,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Skeleton,
  Grid,
} from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  Add,
  Edit,
  Delete,
  Visibility,
  Search,
  FilterList,
  Clear,
  Home,
  NavigateNext,
  CloudUpload,
  DirectionsBoat,
  SettingsSuggest,
  Speed,
  Tune,
  AttachMoney,
  Category,
  LabelImportant,
  RotateRight,
  Sailing,
  TrendingUp,
  Note,
  CameraAlt,
  Email,
  Phone,
  LocationOn,
  Flag,
  CalendarToday,
  Person,
  Cameraswitch,
  FileDownload,
} from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* -------------------- INTERFACES -------------------- */
interface Wishlist {
  id: number;
  date: string;
  configuration: any;
}
interface ProspectForm {
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  address: string;
  comment: string; // Ajout du champ comment
  country: string;
  boatshow: string;
  images: string[];
  currentVessel?: string;
  homePort?: string;
  loa?: string;
  currency?: string;
  maxBudget?: number | "";
  cruisingLifestyle?: string;
  type?: string;
}
interface Prospect {
  id: number;
  firstName: string;
  lastName: string;
  mobile: string;
  email?: string;
  address?: string;
  comment?: string; // Ajout du champ comment
  country: string;
  boatshow: string;
  images: string[];
  currentVessel?: string;
  homePort?: string;
  loa?: string;
  currency?: string;
  maxBudget?: number | "";
  createdAt?: string;
  cruisingLifestyle?: string;
  wishlists?: Wishlist[];
  appointments?: any[];
  type?: string;
}
// Nouvelle interface pour les objets pays
interface CountryData {
  name: string;
  code: string; // Code ISO 3166-1 alpha-2 (pour les drapeaux)
  phoneCode?: string; // Code téléphonique international (optionnel)
}

interface AppointmentDetail {
  id: number;
  appointmentDate: string;
  numberOfPeople: number;
  notes: string;
  boatModel: string;
  boatShowName: string;
  location: string;
  startDate: string;
  endDate: string;
  startTime: string;
  frequency: string;
}
// Nouvelle liste de pays (exemple - vous pouvez l'étendre)
const countryList: CountryData[] = [
  { name: "Afghanistan", code: "AF", phoneCode: "+93" },
  { name: "Albania", code: "AL", phoneCode: "+355" },
  { name: "Algeria", code: "DZ", phoneCode: "+213" },
  { name: "Andorra", code: "AD", phoneCode: "+376" },
  { name: "Angola", code: "AO", phoneCode: "+244" },
  { name: "Antigua & Deps", code: "AG", phoneCode: "+1-268" },
  { name: "Argentina", code: "AR", phoneCode: "+54" },
  { name: "Armenia", code: "AM", phoneCode: "+374" },
  { name: "Australia", code: "AU", phoneCode: "+61" },
  { name: "Austria", code: "AT", phoneCode: "+43" },
  { name: "Azerbaijan", code: "AZ", phoneCode: "+994" },
  { name: "Bahamas", code: "BS", phoneCode: "+1-242" },
  { name: "Bahrain", code: "BH", phoneCode: "+973" },
  { name: "Bangladesh", code: "BD", phoneCode: "+880" },
  { name: "Barbados", code: "BB", phoneCode: "+1-246" },
  { name: "Belarus", code: "BY", phoneCode: "+375" },
  { name: "Belgium", code: "BE", phoneCode: "+32" },
  { name: "Belize", code: "BZ", phoneCode: "+501" },
  { name: "Benin", code: "BJ", phoneCode: "+229" },
  { name: "Bhutan", code: "BT", phoneCode: "+975" },
  { name: "Bolivia", code: "BO", phoneCode: "+591" },
  { name: "Bosnia Herzegovina", code: "BA", phoneCode: "+387" },
  { name: "Botswana", code: "BW", phoneCode: "+267" },
  { name: "Brazil", code: "BR", phoneCode: "+55" },
  { name: "Brunei", code: "BN", phoneCode: "+673" },
  { name: "Bulgaria", code: "BG", phoneCode: "+359" },
  { name: "Burkina", code: "BF", phoneCode: "+226" },
  { name: "Burundi", code: "BI", phoneCode: "+257" },
  { name: "Cambodia", code: "KH", phoneCode: "+855" },
  { name: "Cameroon", code: "CM", phoneCode: "+237" },
  { name: "Canada", code: "CA", phoneCode: "+1" },
  { name: "Cape Verde", code: "CV", phoneCode: "+238" },
  { name: "Central African Rep", code: "CF", phoneCode: "+236" },
  { name: "Chad", code: "TD", phoneCode: "+235" },
  { name: "Chile", code: "CL", phoneCode: "+56" },
  { name: "China", code: "CN", phoneCode: "+86" },
  { name: "Colombia", code: "CO", phoneCode: "+57" },
  { name: "Comoros", code: "KM", phoneCode: "+269" },
  { name: "Congo", code: "CG", phoneCode: "+242" },
  { name: "Congo {Democratic Rep}", code: "CD", phoneCode: "+243" },
  { name: "Costa Rica", code: "CR", phoneCode: "+506" },
  { name: "Croatia", code: "HR", phoneCode: "+385" },
  { name: "Cuba", code: "CU", phoneCode: "+53" },
  { name: "Cyprus", code: "CY", phoneCode: "+357" },
  { name: "Czech Republic", code: "CZ", phoneCode: "+420" },
  { name: "Denmark", code: "DK", phoneCode: "+45" },
  { name: "Djibouti", code: "DJ", phoneCode: "+253" },
  { name: "Dominica", code: "DM", phoneCode: "+1-767" },
  {
    name: "Dominican Republic",
    code: "DO",
    phoneCode: "+1-809, +1-829, +1-849",
  },
  { name: "East Timor", code: "TL", phoneCode: "+670" },
  { name: "Ecuador", code: "EC", phoneCode: "+593" },
  { name: "Egypt", code: "EG", phoneCode: "+20" },
  { name: "El Salvador", code: "SV", phoneCode: "+505" },
  { name: "Equatorial Guinea", code: "GQ", phoneCode: "+240" },
  { name: "Eritrea", code: "ER", phoneCode: "+291" },
  { name: "Estonia", code: "EE", phoneCode: "+372" },
  { name: "Ethiopia", code: "ET", phoneCode: "+251" },
  { name: "Fiji", code: "FJ", phoneCode: "+679" },
  { name: "Finland", code: "FI", phoneCode: "+358" },
  { name: "France", code: "FR", phoneCode: "+33" },
  { name: "Gabon", code: "GA", phoneCode: "+241" },
  { name: "Gambia", code: "GM", phoneCode: "+220" },
  { name: "Georgia", code: "GE", phoneCode: "+995" },
  { name: "Germany", code: "DE", phoneCode: "+49" },
  { name: "Ghana", code: "GH", phoneCode: "+233" },
  { name: "Greece", code: "GR", phoneCode: "+30" },
  { name: "Grenada", code: "GD", phoneCode: "+1-473" },
  { name: "Guatemala", code: "GT", phoneCode: "+502" },
  { name: "Guinea", code: "GN", phoneCode: "+224" },
  { name: "Guinea-Bissau", code: "GW", phoneCode: "+245" },
  { name: "Guyana", code: "GY", phoneCode: "+592" },
  { name: "Haiti", code: "HT", phoneCode: "+509" },
  { name: "Honduras", code: "HN", phoneCode: "+504" },
  { name: "Hungary", code: "HU", phoneCode: "+36" },
  { name: "Iceland", code: "IS", phoneCode: "+354" },
  { name: "India", code: "IN", phoneCode: "+91" },
  { name: "Indonesia", code: "ID", phoneCode: "+62" },
  { name: "Iran", code: "IR", phoneCode: "+98" },
  { name: "Iraq", code: "IQ", phoneCode: "+964" },
  { name: "Ireland {Republic}", code: "IE", phoneCode: "+353" },
  { name: "Israel", code: "IL", phoneCode: "+972" },
  { name: "Italy", code: "IT", phoneCode: "+39" },
  { name: "Ivory Coast", code: "CI", phoneCode: "+225" },
  { name: "Jamaica", code: "JM", phoneCode: "+1-876" },
  { name: "Japan", code: "JP", phoneCode: "+81" },
  { name: "Jordan", code: "JO", phoneCode: "+962" },
  { name: "Kazakhstan", code: "KZ", phoneCode: "+7" },
  { name: "Kenya", code: "KE", phoneCode: "+254" },
  { name: "Kiribati", code: "KI", phoneCode: "+686" },
  { name: "Korea North", code: "KP", phoneCode: "+850" },
  { name: "Korea South", code: "KR", phoneCode: "+82" },
  { name: "Kosovo", code: "XK", phoneCode: "+383" },
  { name: "Kuwait", code: "KW", phoneCode: "+965" },
  { name: "Kyrgyzstan", code: "KG", phoneCode: "+996" },
  { name: "Laos", code: "LA", phoneCode: "+856" },
  { name: "Latvia", code: "LV", phoneCode: "+371" },
  { name: "Lebanon", code: "LB", phoneCode: "+961" },
  { name: "Lesotho", code: "LS", phoneCode: "+266" },
  { name: "Liberia", code: "LR", phoneCode: "+231" },
  { name: "Libya", code: "LY", phoneCode: "+218" },
  { name: "Liechtenstein", code: "LI", phoneCode: "+423" },
  { name: "Lithuania", code: "LT", phoneCode: "+370" },
  { name: "Luxembourg", code: "LU", phoneCode: "+352" },
  { name: "Macedonia", code: "MK", phoneCode: "+389" },
  { name: "Madagascar", code: "MG", phoneCode: "+261" },
  { name: "Malawi", code: "MW", phoneCode: "+265" },
  { name: "Malaysia", code: "MY", phoneCode: "+60" },
  { name: "Maldives", code: "MV", phoneCode: "+960" },
  { name: "Mali", code: "ML", phoneCode: "+223" },
  { name: "Malta", code: "MT", phoneCode: "+356" },
  { name: "Marshall Islands", code: "MH", phoneCode: "+692" },
  { name: "Mauritania", code: "MR", phoneCode: "+222" },
  { name: "Mauritius", code: "MU", phoneCode: "+230" },
  { name: "Mexico", code: "MX", phoneCode: "+52" },
  { name: "Micronesia", code: "FM", phoneCode: "+691" },
  { name: "Moldova", code: "MD", phoneCode: "+373" },
  { name: "Monaco", code: "MC", phoneCode: "+377" },
  { name: "Mongolia", code: "MN", phoneCode: "+976" },
  { name: "Montenegro", code: "ME", phoneCode: "+382" },
  { name: "Morocco", code: "MA", phoneCode: "+212" },
  { name: "Mozambique", code: "MZ", phoneCode: "+258" },
  { name: "Myanmar, {Burma}", code: "MM", phoneCode: "+95" },
  { name: "Namibia", code: "NA", phoneCode: "+264" },
  { name: "Nauru", code: "NR", phoneCode: "+674" },
  { name: "Nepal", code: "NP", phoneCode: "+977" },
  { name: "Netherlands", code: "NL", phoneCode: "+31" },
  { name: "New Zealand", code: "NZ", phoneCode: "+64" },
  { name: "Nicaragua", code: "NI", phoneCode: "+505" },
  { name: "Niger", code: "NE", phoneCode: "+227" },
  { name: "Nigeria", code: "NG", phoneCode: "+234" },
  { name: "Norway", code: "NO", phoneCode: "+47" },
  { name: "Oman", code: "OM", phoneCode: "+968" },
  { name: "Pakistan", code: "PK", phoneCode: "+92" },
  { name: "Palau", code: "PW", phoneCode: "+680" },
  { name: "Panama", code: "PA", phoneCode: "+507" },
  { name: "Papua New Guinea", code: "PG", phoneCode: "+675" },
  { name: "Paraguay", code: "PY", phoneCode: "+595" },
  { name: "Peru", code: "PE", phoneCode: "+51" },
  { name: "Philippines", code: "PH", phoneCode: "+63" },
  { name: "Poland", code: "PL", phoneCode: "+48" },
  { name: "Portugal", code: "PT", phoneCode: "+351" },
  { name: "Qatar", code: "QA", phoneCode: "+974" },
  { name: "Romania", code: "RO", phoneCode: "+40" },
  { name: "Russian Federation", code: "RU", phoneCode: "+7" },
  { name: "Rwanda", code: "RW", phoneCode: "+250" },
  { name: "St Kitts & Nevis", code: "KN", phoneCode: "+1-869" },
  { name: "St Lucia", code: "LC", phoneCode: "+1-758" },
  { name: "Saint Vincent & the Grenadines", code: "VC", phoneCode: "+1-784" },
  { name: "Samoa", code: "WS", phoneCode: "+685" },
  { name: "San Marino", code: "SM", phoneCode: "+378" },
  { name: "Sao Tome & Principe", code: "ST", phoneCode: "+239" },
  { name: "Saudi Arabia", code: "SA", phoneCode: "+966" },
  { name: "Senegal", code: "SN", phoneCode: "+221" },
  { name: "Serbia", code: "RS", phoneCode: "+381" },
  { name: "Seychelles", code: "SC", phoneCode: "+248" },
  { name: "Sierra Leone", code: "SL", phoneCode: "+232" },
  { name: "Singapore", code: "SG", phoneCode: "+65" },
  { name: "Slovakia", code: "SK", phoneCode: "+421" },
  { name: "Slovenia", code: "SI", phoneCode: "+386" },
  { name: "Solomon Islands", code: "SB", phoneCode: "+677" },
  { name: "Somalia", code: "SO", phoneCode: "+252" },
  { name: "South Africa", code: "ZA", phoneCode: "+27" },
  { name: "South Sudan", code: "SS", phoneCode: "+211" },
  { name: "Spain", code: "ES", phoneCode: "+34" },
  { name: "Sri Lanka", code: "LK", phoneCode: "+94" },
  { name: "Sudan", code: "SD", phoneCode: "+249" },
  { name: "Suriname", code: "SR", phoneCode: "+597" },
  { name: "Swaziland", code: "SZ", phoneCode: "+268" },
  { name: "Sweden", code: "SE", phoneCode: "+46" },
  { name: "Switzerland", code: "CH", phoneCode: "+41" },
  { name: "Syria", code: "SY", phoneCode: "+963" },
  { name: "Taiwan", code: "TW", phoneCode: "+886" },
  { name: "Tajikistan", code: "TJ", phoneCode: "+992" },
  { name: "Tanzania", code: "TZ", phoneCode: "+255" },
  { name: "Thailand", code: "TH", phoneCode: "+66" },
  { name: "Togo", code: "TG", phoneCode: "+228" },
  { name: "Tonga", code: "TO", phoneCode: "+676" },
  { name: "Trinidad & Tobago", code: "TT", phoneCode: "+1-868" },
  { name: "Tunisia", code: "TN", phoneCode: "+216" },
  { name: "Turkey", code: "TR", phoneCode: "+90" },
  { name: "Turkmenistan", code: "TM", phoneCode: "+993" },
  { name: "Tuvalu", code: "TV", phoneCode: "+688" },
  { name: "Uganda", code: "UG", phoneCode: "+256" },
  { name: "Ukraine", code: "UA", phoneCode: "+380" },
  { name: "United Arab Emirates", code: "AE", phoneCode: "+971" },
  { name: "United Kingdom", code: "GB", phoneCode: "+44" },
  { name: "United States", code: "US", phoneCode: "+1" },
  { name: "Uruguay", code: "UY", phoneCode: "+598" },
  { name: "Uzbekistan", code: "UZ", phoneCode: "+998" },
  { name: "Vanuatu", code: "VU", phoneCode: "+678" },
  { name: "Vatican City", code: "VA", phoneCode: "+379" },
  { name: "Venezuela", code: "VE", phoneCode: "+58" },
  { name: "Vietnam", code: "VN", phoneCode: "+84" },
  { name: "Yemen", code: "YE", phoneCode: "+967" },
  { name: "Zambia", code: "ZM", phoneCode: "+260" },
  { name: "Zimbabwe", code: "ZW", phoneCode: "+263" },
  // ... Ajoutez les autres pays selon vos besoins
];
const cruisingLifestyles = ["Cruising", "Racing", "Fishing", "Sailing"];
const currencies = ["USD", "EUR", "GBP", "AUD", "CAD", "JPY", "CHF"];
const prospectTypes = ["Particulier", "Dealer", "Broker"];
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_Image;
/* -------------------- COMPONENT -------------------- */
const ProspectsPage: React.FC = () => {
  const [isCameraActive, setIsCameraActive] = useState(false);
  const webcamRef = useRef<Webcam>(null);
  const [prospects, setProspects] = useState<Prospect[]>([]);
  const [modalType, setModalType] = useState<"add" | "edit" | "view" | null>(
    null,
  );
  const [form, setForm] = useState<Omit<Prospect, "id">>({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    address: "",
    comment: "", // Initialisation du champ comment
    country: "",
    boatshow: "",
    images: [],
    currentVessel: "",
    homePort: "",
    loa: "",
    currency: "",
    maxBudget: "",
    cruisingLifestyle: "",
    type: "",
  });
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [dragOver, setDragOver] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState<string>("all");
  const [boatShowFilter, setBoatShowFilter] = useState<string>("all");
  const [typeFilter, setTypeFilter] = useState<string>("all");
  const [viewMode, setViewMode] = useState<"table" | "grid">("table");
  const [boatShows, setBoatShows] = useState<string[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isWishlistsDialogOpen, setIsWishlistsDialogOpen] = useState(false);
  const [selectedProspectWishlists, setSelectedProspectWishlists] = useState<
    Wishlist[]
  >([]);
  const [showOtherCurrencyField, setShowOtherCurrencyField] = useState(false);
  const [imageFiles, setImageFiles] = useState<(File | null)[]>(new Array(10).fill(null));
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [prospectToDelete, setProspectToDelete] = useState<Prospect | null>(
    null,
  );
  const [facingMode, setFacingMode] = useState<"user" | "environment">("user");
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>(""); // État temporaire pour le code pays sélectionné
  const fileInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // États pour la pagination de la table personnalisée
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [isAppointmentsDialogOpen, setIsAppointmentsDialogOpen] =
    useState(false);
  const [selectedProspectAppointments, setSelectedProspectAppointments] =
    useState<AppointmentDetail[]>([]);

  /* -------------------- API CALLS -------------------- */

  const fetchProspectAppointments = async (prospectId: number) => {
    try {
      const response = await axios.get(
        `${API_URL}/boatshow-appointments/prospect/${prospectId}`,
      );
      console.log(response.data.length);

      setSelectedProspectAppointments(response.data);
      setIsAppointmentsDialogOpen(true);
    } catch (err) {
      console.error("Error fetching prospect appointments:", err);
      toast.error("Failed to load appointment details.");
    }
  };
  const fetchProspects = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/prospects`);
      console.log(res.data);
      const prospectsWithWishlists = await Promise.all(
        res.data.map(async (prospect: Prospect) => {
          try {
            const wishlistRes = await axios.get(
              `${API_URL}/wishlists/prospect/${prospect.id}`,
            );
            return { ...prospect, wishlists: wishlistRes.data };
          } catch (wishlistErr) {
            console.error(
              `Error fetching wishlists for prospect ${prospect.id}:`,
              wishlistErr,
            );
            return { ...prospect, wishlists: [] };
          }
        }),
      );
      setProspects(prospectsWithWishlists);
    } catch (err) {
      console.error("Error fetching prospects:", err);
      toast.error("Failed to load prospects. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const fetchBoatShows = async () => {
    try {
      const response = await axios.get(`${API_URL}/boatshows`);
      const shows = response.data.map((show: any) => show.name);
      setBoatShows(shows);
    } catch (err) {
      console.error("Error fetching boat shows:", err);
      toast.error("Failed to load boat shows.");
    }
  };
  const createProspect = async () => {
    try {
      const formData = new FormData();
      // Ajoutez tous les champs du formulaire au FormData
      Object.keys(form).forEach((key) => {
        if (form[key as keyof typeof form]) {
          formData.append(key, form[key as keyof typeof form] as string);
        }
      });
      // Ajoutez les fichiers images
      imageFiles.forEach((file, index) => {
        if (file) {
          formData.append(`image${index + 1}`, file);
        }
      });
      const res = await axios.post(`${API_URL}/prospects`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const newProspect = { ...res.data, wishlists: [] };
      setProspects((prev) => [...prev, newProspect]);
      toast.success("Prospect created successfully! 🎉");
      fetchProspects();
      fetchBoatShows();
    } catch (err) {
      console.error("Error creating prospect:", err);
      toast.error("Failed to create prospect.");
    }
  };
  const updateProspect = async () => {
    if (!selectedId) return;
    try {
      const formData = new FormData();
      // Ajoutez tous les champs du formulaire au FormData
      Object.keys(form).forEach((key) => {
        if (form[key as keyof typeof form]) {
          formData.append(key, form[key as keyof typeof form] as string);
        }
      });
      // Ajoutez les nouveaux fichiers images
      imageFiles.forEach((file, index) => {
        if (file) {
          formData.append(`image${index + 1}`, file);
        }
      });
      const res = await axios.put(
        `${API_URL}/prospects/${selectedId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setProspects((prev) =>
        prev.map((p) =>
          p.id === selectedId ? { ...res.data, wishlists: p.wishlists } : p,
        ),
      );
      toast.success("Prospect updated successfully! ✨");
      fetchProspects();
      fetchBoatShows();
    } catch (err) {
      console.error("Error updating prospect:", err);
      toast.error("Failed to update prospect.");
    }
  };
  const deleteProspect = async (id: number) => {
    try {
      await axios.delete(`${API_URL}/prospects/${id}`);
      setProspects((prev) => prev.filter((p) => p.id !== id));
      toast.info("Prospect deleted. 🗑️");
      fetchProspects();
      fetchBoatShows();
    } catch (err) {
      console.error("Error deleting prospect:", err);
      toast.error("Failed to delete prospect.");
    }
  };
  useEffect(() => {
    fetchProspects();
    fetchBoatShows();
  }, []);
  const handleDeleteProspect = (prospect: Prospect) => {
    setProspectToDelete(prospect);
    setIsDeleteDialogOpen(true);
  };
  const confirmDeleteProspect = async () => {
    if (!prospectToDelete) return;
    try {
      await axios.delete(`${API_URL}/prospects/${prospectToDelete.id}`);
      setProspects((prev) => prev.filter((p) => p.id !== prospectToDelete.id));
      toast.success("Prospect deleted successfully!");
      setIsDeleteDialogOpen(false);
      setProspectToDelete(null);
    } catch (err) {
      console.error("Error deleting prospect:", err);
      toast.error("Failed to delete prospect.");
    }
  };
  const cancelDelete = () => {
    setIsDeleteDialogOpen(false);
    setProspectToDelete(null);
  };
  /* -------------------- VALIDATION -------------------- */
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!form.firstName) newErrors.firstName = "First Name is required";
    if (!form.lastName) newErrors.lastName = "Last Name is required";
    if (!form.mobile) newErrors.mobile = "Mobile is required";
    if (!form.country) newErrors.country = "Country is required";
    if (!form.type) newErrors.type = "Type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  /* -------------------- FILTERED PROSPECTS -------------------- */
  const filteredProspects = prospects.filter((prospect) => {
    const matchesSearch =
      prospect.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      prospect.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      prospect.mobile?.includes(searchTerm) ||
      prospect.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (prospect.comment &&
        prospect.comment.toLowerCase().includes(searchTerm.toLowerCase())); // Ajout du filtre sur comment
    const matchesCountry =
      countryFilter === "all" || prospect.country === countryFilter;
    const matchesBoatShow =
      boatShowFilter === "all" || prospect.boatshow === boatShowFilter;
    const matchesType = typeFilter === "all" || prospect.type === typeFilter;
    return matchesSearch && matchesCountry && matchesBoatShow && matchesType;
  });
  // Pagination pour la table personnalisée
  const paginatedProspects = filteredProspects.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /* -------------------- CRUD MODAL -------------------- */
  const openModal = (type: "add" | "edit" | "view", id?: number) => {
    setModalType(type);
    setImageFiles(new Array(10).fill(null));
    setErrors({});
    setSelectedCountryCode(""); // Réinitialiser le code pays sélectionné
    if (type === "edit" && id) {
      const p = prospects.find((p) => p.id === id);
      if (p) {
        setForm({ ...p, images: Array.isArray(p.images) ? p.images : [] });
        // Trouver le code ISO à partir du nom du pays
        const countryData = countryList.find((c) => c.name === p.country);
        const countryCode = countryData ? countryData.code : "";
        setSelectedCountryCode(countryCode);
        // Détecter si la devise est "Other" et ajuster l'état
        if (p.currency && !currencies.includes(p.currency)) {
          setShowOtherCurrencyField(true);
        } else {
          setShowOtherCurrencyField(false);
        }
      }
      setSelectedId(id);
    } else if (type === "view" && id) {
      const p = prospects.find((p) => p.id === id);
      if (p) {
        setForm({ ...p, images: Array.isArray(p.images) ? p.images : [] });
      }
    } else {
      setForm({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        address: "",
        comment: "", // Réinitialisation du champ comment
        country: "",
        boatshow: "",
        images: [],
        currentVessel: "",
        homePort: "",
        loa: "",
        currency: "",
        maxBudget: "",
        cruisingLifestyle: "",
        type: "",
      });
      setShowOtherCurrencyField(false); // Réinitialiser pour le mode "add"
    }
  };
  const closeModal = () => {
    setModalType(null);
    setShowOtherCurrencyField(false);
    setSelectedCountryCode(""); // Réinitialiser le code pays sélectionné
  };
  const saveProspect = async () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    if (modalType === "add") {
      await createProspect();
    } else if (modalType === "edit") {
      await updateProspect();
    }
    closeModal();
  };
  const handleViewWishlists = (wishlists: any[] = []) => {
    setSelectedProspectWishlists(wishlists);
    setIsWishlistsDialogOpen(true);
  };
  /* -------------------- IMAGE HANDLERS -------------------- */
  /* -------------------- IMAGE HANDLERS -------------------- */
  const addFile = (file: File) => {
    // Collect all indices occupied by existing images
    const occupiedIndices = (Array.isArray(form.images) ? form.images : []).map((img) => {
      const parts = img.split("_");
      const lastPart = parts[parts.length - 1]; // e.g., "1.png"
      return parseInt(lastPart.split(".")[0]); // e.g., 1
    });

    // Find first slot i (1 to 10) such that i is not in occupiedIndices AND imageFiles[i-1] is null
    let targetIndex = -1;
    for (let i = 1; i <= 10; i++) {
      if (!occupiedIndices.includes(i) && imageFiles[i - 1] === null) {
        targetIndex = i - 1;
        break;
      }
    }

    if (targetIndex !== -1) {
      const newFiles = [...imageFiles];
      newFiles[targetIndex] = file;
      setImageFiles(newFiles);
    } else {
      toast.warning("Maximum of 10 images reached.");
    }
  };

  const removeImage = (index: number, isExisting: boolean) => {
    if (isExisting) {
      const newImages = [...form.images];
      newImages.splice(index, 1);
      setForm({ ...form, images: newImages });
    } else {
      const newFiles = [...imageFiles];
      newFiles[index] = null;
      setImageFiles(newFiles);
    }
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    files.forEach((file) => {
      if (file.type.startsWith("image/")) {
        addFile(file);
      }
    });
  };
  // Ouvre la boîte de dialogue de sélection de fichier
  const handleImageUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  // Ouvre la caméra du périphérique
  const handleCameraCaptureClick = () => {
    setIsCameraActive(true);
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    files.forEach((file) => {
      addFile(file);
    });
    e.target.value = ""; // Reset input
  };
  const takePhoto = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        // Convertir la base64 en objet File
        const byteString = atob(imageSrc.split(",")[1]);
        const mimeString = imageSrc.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const file = new File([ab], `prospect-image-${Date.now()}.png`, {
          type: mimeString,
        });
        addFile(file);
        setIsCameraActive(false); // Désactiver la caméra
      }
    }
  };
  const cancelPhoto = () => {
    setIsCameraActive(false);
  };
  /* -------------------- DATAGRID COLUMNS -------------------- */
  const columns: GridColDef[] = [
    {
      field: "image",
      headerName: "Image",
      width: 80,
      renderCell: (params: GridRenderCellParams<any, Prospect>) =>
        params.row.images && params.row.images.length > 0 ? (
          <Avatar
            src={IMAGE_URL + "/prospects/" + params.row.images[0]}
            sx={{ width: 40, height: 40 }}
          />
        ) : (
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "rgba(196,176,140,0.2)",
            }}
          >
            {params.row.firstName.charAt(0)}
            {params.row.lastName.charAt(0)}
          </Avatar>
        ),
    },
    { field: "firstName", headerName: "First Name", flex: 1, minWidth: 120 },
    { field: "lastName", headerName: "Last Name", flex: 1, minWidth: 120 },
    { field: "mobile", headerName: "Mobile", flex: 1, minWidth: 140 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 160 },
    {
      field: "country",
      headerName: "Country",
      flex: 1,
      minWidth: 120, // Augmenté un peu pour le drapeau
      renderCell: (params: GridRenderCellParams<any, Prospect>) => {
        const countryData = countryList.find(
          (c) => c.name === String(params.value),
        );
        return (
          <Box display="flex" alignItems="center" gap={1}>
            {countryData && (
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${countryData.code.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${countryData.code.toLowerCase()}.png 2x`}
                alt={`${countryData.name} flag`}
              />
            )}
            <Chip
              label={String(params.value)}
              size="small"
              color={
                String(params.value) === "France"
                  ? "primary"
                  : String(params.value) === "Spain"
                    ? "secondary"
                    : "default"
              }
            />
          </Box>
        );
      },
    },
    {
      field: "boatshow",
      headerName: "Boat Show",
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridRenderCellParams<any, Prospect>) => (
        <span>{String(params.value) || "-"}</span>
      ),
    },
    // {
    //   field: "type",
    //   headerName: "Type",
    //   flex: 1,
    //   minWidth: 150,
    //   renderCell: (params: GridRenderCellParams<any, Prospect>) => (
    //     <Typography variant="body2" noWrap>
    //       {String(params.value) || "-"}
    //     </Typography>
    //   ),
    // },
    {
      field: "comment",
      headerName: "Comment",
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridRenderCellParams<any, Prospect>) => (
        <Typography variant="body2" noWrap>
          {String(params.value) || "-"}
        </Typography>
      ),
    },
    {
      field: "wishlists",
      headerName: "Wishlists",
      width: 120,
      sortable: false,
      renderCell: (params: GridRenderCellParams<any, Prospect>) => (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          onClick={() => handleViewWishlists(params.row.wishlists)}
          sx={{ cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
        >
          <DirectionsBoat fontSize="small" color="action" />
          <Typography variant="body2" fontWeight="bold">
            {params.row.wishlists?.length || 0}
          </Typography>
        </Box>
      ),
    },
    {
      field: "appointments",
      headerName: "Appointments",
      width: 120,
      sortable: false,
      renderCell: (params: GridRenderCellParams<any, Prospect>) => (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          onClick={() => fetchProspectAppointments(params.row.id)}
          sx={{ cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
        ></Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 140,
      sortable: false,
      renderCell: (params: GridRenderCellParams<any, Prospect>) => (
        <Box display="flex" gap={1}>
          <Tooltip title="View">
            <IconButton
              onClick={() => openModal("view", params.row.id)}
              sx={{ color: "#C4B08C" }}
              size="small"
            >
              <Visibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => openModal("edit", params.row.id)}
              sx={{ color: "#111" }}
              size="small"
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setSelectedId(params.row.id);
                setIsDeleteDialogOpen(true);
              }}
              sx={{ color: "#d32f2f" }}
              size="small"
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
  /* -------------------- CUSTOM TABLE COLUMNS -------------------- */
  const tableColumns = [
    { id: "image", label: "Image", minWidth: 80 },
    { id: "name", label: "Name", minWidth: 150 },
    { id: "contact", label: "Contact", minWidth: 200 },
    { id: "location", label: "Location", minWidth: 150 },
    { id: "boatshow", label: "Boat Show", minWidth: 150 },
    { id: "type", label: "Type", minWidth: 120 }, // Ajout de la colonne Type

    { id: "comment", label: "Comment", minWidth: 150 }, // Ajout de la colonne Comment
    { id: "wishlists", label: "Wishlists", minWidth: 100 },
    { id: "actions", label: "Actions", minWidth: 150, align: "right" as const },
  ];
  /* -------------------- CLEAR FILTERS -------------------- */
  const clearFilters = () => {
    setSearchTerm("");
    setCountryFilter("all");
    setBoatShowFilter("all");
    setTypeFilter("all");
  };
  /* -------------------- EXPORT TO EXCEL -------------------- */
  const exportToExcel = () => {
    try {
      // Prepare data for export
      const exportData = filteredProspects.map((prospect) => ({
        "First Name": prospect.firstName,
        "Last Name": prospect.lastName,
        Mobile: prospect.mobile,
        Email: prospect.email || "-",
        Address: prospect.address || "-",
        Country: prospect.country,
        "Boat Show": prospect.boatshow || "-",
        Type: prospect.type || "-",
        Comment: prospect.comment || "-",
        "Current Vessel": prospect.currentVessel || "-",
        "Home Port": prospect.homePort || "-",
        LOA: prospect.loa || "-",
        Currency: prospect.currency || "-",
        "Max Budget": prospect.maxBudget || "-",
        "Cruising Lifestyle": prospect.cruisingLifestyle || "-",
        "Wishlists Count": prospect.wishlists?.length || 0,
        "Created At": prospect.createdAt
          ? new Date(prospect.createdAt).toLocaleDateString()
          : "-",
      }));

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths
      const columnWidths = [
        { wch: 15 }, // First Name
        { wch: 15 }, // Last Name
        { wch: 15 }, // Mobile
        { wch: 25 }, // Email
        { wch: 30 }, // Address
        { wch: 15 }, // Country
        { wch: 20 }, // Boat Show
        { wch: 15 }, // Type
        { wch: 30 }, // Comment
        { wch: 20 }, // Current Vessel
        { wch: 15 }, // Home Port
        { wch: 10 }, // LOA
        { wch: 10 }, // Currency
        { wch: 15 }, // Max Budget
        { wch: 20 }, // Cruising Lifestyle
        { wch: 15 }, // Wishlists Count
        { wch: 15 }, // Created At
      ];
      worksheet["!cols"] = columnWidths;

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Prospects");

      // Generate filename with current date
      const fileName = `Prospects_${new Date().toISOString().split("T")[0]}.xlsx`;

      // Download file
      XLSX.writeFile(workbook, fileName);

      toast.success("Excel file exported successfully! 📊");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Failed to export to Excel.");
    }
  };
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* Breadcrumbs */}
      <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 2 }}>
        <Link
          color="inherit"
          href="#"
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Home sx={{ mr: 0.5, fontSize: 20 }} />
          Home
        </Link>
        <Typography color="text.primary">Prospects</Typography>
      </Breadcrumbs>
      {/* HEADER */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4" fontWeight={700}>
          Prospects Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => openModal("add")}
          sx={{
            bgcolor: "#C4B08C",
            color: "#000",
            "&:hover": { bgcolor: "#b39d77" },
            px: 3,
            py: 1,
            borderRadius: 2,
            fontSize: isMobile ? "0.875rem" : "1rem",
          }}
        >
          {isMobile ? "Add" : "Add Prospect"}
        </Button>
      </Box>
      {/* SEARCH AND FILTERS */}
      <Paper
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <Box
          display="flex"
          flexDirection={isSmallScreen ? "column" : "row"}
          gap={2}
        >
          <TextField
            fullWidth
            placeholder="Search prospects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm("")}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            size="small"
            sx={{
              bgcolor: "white",
              borderRadius: 1,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(0,0,0,0.1)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0,0,0,0.2)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C4B08C",
                },
              },
            }}
          />
          <Box display="flex" gap={1} flex={isSmallScreen ? 1 : 0}>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel>Type</InputLabel>
              <Select
                value={typeFilter}
                label="Type"
                onChange={(e) => setTypeFilter(e.target.value)}
                sx={{
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <MenuItem value="all">
                  <em>All Types</em>
                </MenuItem>
                {prospectTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    <Chip
                      label={type}
                      size="small"
                      sx={{
                        bgcolor:
                          type === "Particulier"
                            ? "#4caf50"
                            : type === "Dealer"
                              ? "#ff9800"
                              : "rgba(196,176,140,0.1)",
                        color:
                          type === "Particulier" || type === "Dealer"
                            ? "#fff"
                            : "#C4B08C",
                        fontWeight: 500,
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              {" "}
              {/* Augmenté minWidth */}
              <InputLabel>Country</InputLabel>
              <Select
                value={countryFilter}
                label="Country"
                onChange={(e) => setCountryFilter(e.target.value as string)} // Cast explicite
                sx={{
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <MenuItem value="all">
                  <em>All Countries</em>
                </MenuItem>
                {countryList.map((country) => (
                  <MenuItem key={country.code} value={country.name}>
                    {" "}
                    {/* Utiliser le nom comme valeur pour le filtre */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                        alt={`${country.name} flag`}
                      />
                      <Typography variant="body2">{country.name}</Typography>
                      {/* Optionnellement, afficher le code téléphonique */}
                      {/* {country.phoneCode && <Typography variant="caption" color="textSecondary" ml={1}>({country.phoneCode})</Typography>} */}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel>Boat Show</InputLabel>
              <Select
                value={boatShowFilter}
                label="Boat Show"
                onChange={(e) => setBoatShowFilter(e.target.value)}
                sx={{
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <MenuItem value="all">All Shows</MenuItem>
                {boatShows.map((show) => (
                  <MenuItem key={show} value={show}>
                    {show}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {(searchTerm ||
              countryFilter !== "all" ||
              boatShowFilter !== "all" ||
              typeFilter !== "all") && (
                <Button
                  onClick={clearFilters}
                  startIcon={<Clear />}
                  size="small"
                  sx={{
                    whiteSpace: "nowrap",
                    bgcolor: "rgba(196,176,140,0.1)",
                    color: "#C4B08C",
                    "&:hover": {
                      bgcolor: "rgba(196,176,140,0.2)",
                    },
                  }}
                >
                  Clear
                </Button>
              )}
          </Box>
        </Box>
      </Paper>
      {/* VIEW TOGGLE */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Button
          variant="contained"
          startIcon={<FileDownload />}
          onClick={exportToExcel}
          sx={{
            bgcolor: "#C4B08C",
            color: "#000",
            "&:hover": { bgcolor: "#b39d77" },
            px: 3,
            py: 1,
            borderRadius: 2,
            fontSize: isMobile ? "0.875rem" : "1rem",
          }}
        >
          {isMobile ? "Export" : "Export to Excel"}
        </Button>
        <Box display="flex">
          <Button
            variant={viewMode === "table" ? "contained" : "outlined"}
            size="small"
            onClick={() => setViewMode("table")}
            sx={{
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              bgcolor: viewMode === "table" ? "#C4B08C" : undefined,
              color: viewMode === "table" ? "#000" : undefined,
              "&:hover": {
                bgcolor: viewMode === "table" ? "#b39d77" : undefined,
                color: viewMode === "table" ? "#000" : undefined,
              },
              borderColor: "#C4B08C",
            }}
          >
            Table
          </Button>
          <Button
            variant={viewMode === "grid" ? "contained" : "outlined"}
            size="small"
            onClick={() => setViewMode("grid")}
            sx={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              ml: "-1px",
              bgcolor: viewMode === "grid" ? "#C4B08C" : undefined,
              color: viewMode === "grid" ? "#000" : undefined,
              "&:hover": {
                bgcolor: viewMode === "grid" ? "#b39d77" : undefined,
                color: viewMode === "grid" ? "#000" : undefined,
              },
              borderColor: "#C4B08C",
            }}
          >
            Grid
          </Button>
        </Box>
      </Box>
      {/* TABLE VIEW */}
      {viewMode === "table" && (
        <Paper
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,.08)",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {tableColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#f8f5f0",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        color="#555"
                      >
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  // Skeleton loading rows
                  Array.from(new Array(rowsPerPage)).map((_, index) => (
                    <TableRow key={index}>
                      {tableColumns.map((column) => (
                        <TableCell key={column.id}>
                          <Skeleton animation="wave" height={40} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : paginatedProspects.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={tableColumns.length} align="center">
                      <Box py={5} textAlign="center">
                        <FilterList
                          sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}
                        />
                        <Typography
                          variant="h6"
                          color="text.secondary"
                          gutterBottom
                        >
                          No prospects found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Try adjusting your search or filters
                        </Typography>
                        {(searchTerm ||
                          countryFilter !== "all" ||
                          boatShowFilter !== "all" ||
                          typeFilter !== "all") && (
                            <Button
                              onClick={clearFilters}
                              sx={{ mt: 2 }}
                              variant="outlined"
                            >
                              Clear all filters
                            </Button>
                          )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedProspects.map((prospect) => (
                    <TableRow
                      key={prospect.id}
                      hover
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": {
                          backgroundColor: "rgba(196,176,140,0.04)",
                        },
                      }}
                    >
                      <TableCell>
                        {prospect.images && prospect.images.length > 0 ? (
                          <Avatar
                            src={IMAGE_URL + "/prospects/" + prospect.images[0]}
                            sx={{ width: 40, height: 40 }}
                          />
                        ) : (
                          <Avatar
                            sx={{
                              width: 40,
                              height: 40,
                              bgcolor: "rgba(196,176,140,0.2)",
                              color: "#C4B08C",
                            }}
                          >
                            {prospect.firstName.charAt(0)}
                            {prospect.lastName.charAt(0)}
                          </Avatar>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body1" fontWeight={500}>
                            {prospect.firstName} {prospect.lastName}
                          </Typography>
                          <Box display="flex" alignItems="center" mt={0.5}>
                            <CalendarToday
                              sx={{
                                fontSize: 14,
                                color: "text.secondary",
                                mr: 0.5,
                              }}
                            />
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              ID: {prospect.id}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          <Box display="flex" alignItems="center">
                            <Phone
                              sx={{
                                fontSize: 16,
                                color: "text.secondary",
                                mr: 1,
                              }}
                            />
                            <Typography variant="body2">
                              {prospect.mobile}
                            </Typography>
                          </Box>
                          {prospect.email && (
                            <Box display="flex" alignItems="center">
                              <Email
                                sx={{
                                  fontSize: 16,
                                  color: "text.secondary",
                                  mr: 1,
                                }}
                              />
                              <Typography variant="body2">
                                {prospect.email}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          {prospect.country &&
                            (() => {
                              const countryData = countryList.find(
                                (c) => c.name === prospect.country,
                              );
                              return (
                                <Box display="flex" alignItems="center">
                                  {countryData && (
                                    <img
                                      loading="lazy"
                                      width="20"
                                      src={`https://flagcdn.com/w20/${countryData.code.toLowerCase()}.png`}
                                      srcSet={`https://flagcdn.com/w40/${countryData.code.toLowerCase()}.png 2x`}
                                      alt={`${countryData.name} flag`}
                                      style={{ marginRight: "8px" }} // Remplace le mr de l'icône
                                    />
                                  )}
                                  <Chip
                                    label={prospect.country}
                                    size="small"
                                    sx={{
                                      height: 20,
                                      bgcolor:
                                        prospect.country === "France"
                                          ? "primary.light"
                                          : prospect.country === "Spain"
                                            ? "secondary.light"
                                            : "default",
                                      color: "white",
                                    }}
                                  />
                                </Box>
                              );
                            })()}
                          {prospect.address && (
                            <Box display="flex" alignItems="center" mt={0.5}>
                              <LocationOn
                                sx={{
                                  fontSize: 16,
                                  color: "text.secondary",
                                  mr: 1,
                                }}
                              />
                              <Typography
                                variant="caption"
                                noWrap
                                maxWidth={150}
                              >
                                {prospect.address}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {prospect.boatshow ? (
                          <Chip
                            label={prospect.boatshow}
                            size="small"
                            sx={{
                              bgcolor: "rgba(196,176,140,0.1)",
                              color: "#C4B08C",
                              fontWeight: 500,
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {prospect.type ? (
                          <Chip
                            label={prospect.type}
                            size="small"
                            sx={{
                              bgcolor:
                                prospect.type === "Particulier"
                                  ? "#4caf50"
                                  : prospect.type === "Dealer"
                                    ? "#ff9800"
                                    : "rgba(196,176,140,0.1)",
                              color:
                                prospect.type === "Particulier" ||
                                  prospect.type === "Dealer"
                                  ? "#fff"
                                  : "#C4B08C",
                              fontWeight: 500,
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" noWrap>
                          {prospect.comment || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          onClick={() =>
                            handleViewWishlists(prospect.wishlists)
                          }
                          sx={{
                            cursor: "pointer",
                            "&:hover": {
                              textDecoration: "underline",
                              color: "#C4B08C",
                            },
                          }}
                        >
                          <DirectionsBoat
                            fontSize="small"
                            sx={{ color: "#C4B08C" }}
                          />
                          <Typography variant="body2" fontWeight="bold">
                            {prospect.wishlists?.length || 0}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box display="flex" justifyContent="flex-end" gap={0.5}>
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => openModal("view", prospect.id)}
                              sx={{
                                color: "#C4B08C",
                                "&:hover": {
                                  bgcolor: "rgba(196,176,140,0.1)",
                                },
                              }}
                              size="small"
                            >
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => openModal("edit", prospect.id)}
                              sx={{
                                color: "#111",
                                "&:hover": {
                                  bgcolor: "rgba(0,0,0,0.05)",
                                },
                              }}
                              size="small"
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => handleDeleteProspect(prospect)}
                              sx={{
                                color: "#d32f2f",
                                "&:hover": {
                                  bgcolor: "rgba(211,47,47,0.1)",
                                },
                              }}
                              size="small"
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredProspects.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              "& .MuiTablePagination-toolbar": {
                pl: 2,
                pr: 2,
              },
            }}
          />
        </Paper>
      )}
      {/* GRID VIEW */}
      {viewMode === "grid" && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(2),
            "& > *": {
              flex: "1 1 200px", // Responsive items
              minWidth: { xs: "100%", sm: "48%", md: "31%", lg: "23%" },
            },
          }}
        >
          {filteredProspects.map((prospect) => (
            <Card
              key={prospect.id}
              sx={{
                borderRadius: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,.08)",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(0,0,0,.12)",
                },
              }}
            >
              <CardContent sx={{ textAlign: "center", pb: 1 }}>
                {prospect.images && prospect.images.length > 0 ? (
                  <Avatar
                    src={IMAGE_URL + "/prospects/" + prospect.images[0]}
                    sx={{ width: 60, height: 60, mx: "auto", mb: 2 }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: 60,
                      height: 60,
                      mx: "auto",
                      mb: 2,
                      bgcolor: "rgba(196,176,140,0.2)",
                    }}
                  >
                    {prospect.firstName.charAt(0)}
                    {prospect.lastName.charAt(0)}
                  </Avatar>
                )}
                <Typography variant="h6" gutterBottom>
                  {prospect.firstName} {prospect.lastName}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {prospect.mobile}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {prospect.email}
                </Typography>
                {(() => {
                  const countryData = countryList.find(
                    (c) => c.name === prospect.country,
                  );
                  return (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      mt={1}
                    >
                      {countryData && (
                        <img
                          loading="lazy"
                          width="20"
                          src={`https://flagcdn.com/w20/${countryData.code.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${countryData.code.toLowerCase()}.png 2x`}
                          alt={`${countryData.name} flag`}
                          style={{ marginRight: "8px" }}
                        />
                      )}
                      <Chip
                        label={prospect.country}
                        size="small"
                        // Vous pouvez garder ou ajuster les couleurs spécifiques
                        sx={
                          {
                            /* ... styles ... */
                          }
                        }
                        color={
                          prospect.country === "France"
                            ? "primary"
                            : prospect.country === "Spain"
                              ? "secondary"
                              : "default"
                        }
                      />
                    </Box>
                  );
                })()}
                {prospect.comment && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1, fontStyle: "italic" }}
                    noWrap
                  >
                    {prospect.comment}
                  </Typography>
                )}
              </CardContent>
              <Divider />
              <CardActions sx={{ justifyContent: "center", py: 1 }}>
                <IconButton
                  onClick={() => openModal("view", prospect.id)}
                  sx={{ color: "#C4B08C" }}
                  size="small"
                >
                  <Visibility />
                </IconButton>
                <IconButton
                  onClick={() => fetchProspectAppointments(prospect.id)}
                  sx={{ color: "#1976d2" }}
                  size="small"
                >
                  <CalendarToday />
                </IconButton>
                <IconButton
                  onClick={() => openModal("edit", prospect.id)}
                  sx={{ color: "#111" }}
                  size="small"
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() => deleteProspect(prospect.id)}
                  sx={{ color: "#d32f2f" }}
                  size="small"
                >
                  <Delete />
                </IconButton>
              </CardActions>
            </Card>
          ))}
        </Box>
      )}
      {/* EMPTY STATE FOR GRID VIEW */}
      {viewMode === "grid" && filteredProspects.length === 0 && !loading && (
        <Paper sx={{ p: 4, textAlign: "center", borderRadius: 2 }}>
          <FilterList sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No prospects found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Try adjusting your search or filters
          </Typography>
          {(searchTerm ||
            countryFilter !== "all" ||
            boatShowFilter !== "all" ||
            typeFilter !== "all") && (
              <Button onClick={clearFilters} sx={{ mt: 2 }}>
                Clear all filters
              </Button>
            )}
        </Paper>
      )}
      {/* ---------- MODAL CRUD ---------- */}
      {modalType && (
        <Dialog
          open
          onClose={(event, reason) => {
            // Only close when the X button is clicked
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              closeModal();
            }
          }}
          fullWidth
          maxWidth="sm"
          fullScreen={isMobile}
          PaperProps={{
            sx: {
              borderRadius: isMobile ? 0 : 2,
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontSize: "1.5rem",
              fontWeight: 600,
              bgcolor: "#f8f5f0",
              py: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {modalType === "add"
              ? "Add New Prospect"
              : modalType === "edit"
                ? "Edit Prospect"
                : "Prospect Details"}
            <IconButton onClick={closeModal} size="small">
              <Clear />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ py: 3 }}>
            {modalType === "view" ? (
              <Box>
                {Array.isArray(form.images) && form.images.length > 0 && (
                  <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                    {form.images.map((img, idx) => (
                      <Box
                        key={idx}
                        component="img"
                        src={IMAGE_URL + "/prospects/" + img}
                        alt={`Prospect image ${idx + 1}`}
                        sx={{
                          width: form.images.length === 1 ? "100%" : "calc(50% - 4px)",
                          borderRadius: 2,
                          maxHeight: 200,
                          objectFit: "cover",
                        }}
                      />
                    ))}
                  </Box>
                )}
                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap={2}
                  sx={{ "& > div": { minWidth: { xs: "100%", sm: "48%" } } }}
                >
                  <Box>
                    <Typography>
                      <strong>First Name:</strong> {form.firstName}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Last Name:</strong> {form.lastName}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Mobile:</strong> {form.mobile}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Email:</strong> {form.email || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Country:</strong> {form.country}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Boat Show:</strong> {form.boatshow || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Current Vessel:</strong>{" "}
                      {form.currentVessel || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Home Port:</strong> {form.homePort || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>LOA:</strong> {form.loa || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Currency:</strong> {form.currency || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Max Budget:</strong> {form.maxBudget || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <strong>Cruising Lifestyle:</strong>{" "}
                      {form.cruisingLifestyle || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Typography>
                      <strong>Address:</strong> {form.address || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    {" "}
                    {/* Ajout de l'affichage du commentaire en mode view */}
                    <Typography>
                      <strong>Comment:</strong> {form.comment || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography component="span">
                      <strong>Type:</strong>{" "}
                    </Typography>
                    {form.type ? (
                      <Chip
                        label={form.type}
                        size="small"
                        sx={{
                          bgcolor:
                            form.type === "Particulier"
                              ? "#4caf50"
                              : form.type === "Dealer"
                                ? "#ff9800"
                                : "rgba(196,176,140,0.1)",
                          color:
                            form.type === "Particulier" ||
                              form.type === "Dealer"
                              ? "#fff"
                              : "#C4B08C",
                          fontWeight: 500,
                          ml: 1,
                        }}
                      />
                    ) : (
                      <Typography component="span" color="text.secondary">
                        non assigné
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2} mt={1.5}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap={2}
                  sx={{ "& > div": { minWidth: { xs: "100%", sm: "48%" } } }}
                >
                  <Box>
                    <TextField
                      fullWidth
                      label="First Name"
                      value={form.firstName}
                      onChange={(e) =>
                        setForm({ ...form, firstName: e.target.value })
                      }
                      error={!!errors.firstName}
                      helperText={errors.firstName}
                      required
                      size="small"
                    />
                  </Box>
                  <Box>
                    <TextField
                      fullWidth
                      label="Last Name"
                      value={form.lastName}
                      onChange={(e) =>
                        setForm({ ...form, lastName: e.target.value })
                      }
                      error={!!errors.lastName}
                      helperText={errors.lastName}
                      required
                      size="small"
                    />
                  </Box>
                  <Box>
                    <FormControl
                      fullWidth
                      required
                      error={!!errors.country}
                      size="small"
                    >
                      {" "}
                      {/* size="small" sur FormControl */}
                      <InputLabel size="small">Country</InputLabel>
                      <Select
                        value={selectedCountryCode}
                        label="Country"
                        onChange={(e) => {
                          const selectedCode = e.target.value as string;
                          setSelectedCountryCode(selectedCode);
                          const selectedCountry = countryList.find(
                            (c) => c.code === selectedCode,
                          );
                          setForm({
                            ...form,
                            country: selectedCountry
                              ? selectedCountry.name
                              : "",
                          });
                        }}
                        size="small" // size="small" sur Select
                        sx={
                          {
                            // Optionnel : Hauteur minimale ou spécifique pour le Select lui-même
                            // minHeight: '32px',
                          }
                        }
                      >
                        {countryList.map((country) => (
                          <MenuItem
                            key={country.code}
                            value={country.code}
                            sx={{
                              minHeight: "auto", // Permet au MenuItem de s'ajuster à son contenu
                              py: 0.25, // Réduire fortement le padding vertical du MenuItem (par défaut c'est souvent 1 ou 0.5)
                              fontSize: "0.8125rem", // Réduire légèrement la taille de la police si nécessaire
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={0.5} // Réduire l'espace entre le drapeau et le texte (était 1)
                              sx={{
                                py: 0.1, // Très petit padding vertical interne si besoin
                              }}
                            >
                              {/* Drapeau plus petit */}
                              <img
                                loading="lazy"
                                width="16" // Réduction de la largeur (était 20)
                                height="12" // Spécification explicite de la hauteur
                                src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                                alt={`${country.name} flag`}
                                style={{
                                  objectFit: "cover", // Assure un bon ajustement de l'image
                                  // borderRadius: '1px' // Optionnel : très petits arrondis
                                }}
                              />
                              {/* Texte potentiellement plus petit */}
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "0.8125rem", // Assurer une taille cohérente et réduite
                                }}
                              >
                                {country.name}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: "250px" }}>
                    {" "}
                    {/* Définir une largeur fixe ici */}
                    <TextField
                      fullWidth
                      label="Mobile"
                      value={form.mobile}
                      onChange={(e) =>
                        setForm({ ...form, mobile: e.target.value })
                      }
                      error={!!errors.mobile}
                      helperText={errors.mobile}
                      required
                      size="small"
                      InputProps={{
                        startAdornment: selectedCountryCode ? (
                          <InputAdornment position="start">
                            <Box display="flex" alignItems="center" gap={0.2}>
                              {/* Afficher le drapeau */}
                              <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${selectedCountryCode.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${selectedCountryCode.toLowerCase()}.png 2x`}
                                alt={`${countryList.find(
                                  (c) => c.code === selectedCountryCode,
                                )?.name || ""
                                  } flag`}
                              />
                              {/* Afficher le phoneCode */}
                              <Typography variant="body2" color="textSecondary">
                                {countryList.find(
                                  (c) => c.code === selectedCountryCode,
                                )?.phoneCode || ""}
                              </Typography>
                            </Box>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Box>
                  <Box>
                    <TextField
                      fullWidth
                      label="Email"
                      value={form.email}
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                      type="email"
                      size="small"
                    />
                  </Box>
                  <Box>
                    <FormControl fullWidth>
                      <InputLabel size="small">Boat Show</InputLabel>
                      <Select
                        value={form.boatshow}
                        label="Boat Show"
                        onChange={(e) =>
                          setForm({ ...form, boatshow: e.target.value })
                        }
                        size="small"
                      >
                        <MenuItem value="">None</MenuItem>
                        {boatShows.map((show) => (
                          <MenuItem key={show} value={show}>
                            {show}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth
                      label="Current Vessel"
                      value={form.currentVessel}
                      onChange={(e) =>
                        setForm({ ...form, currentVessel: e.target.value })
                      }
                      size="small"
                    />
                  </Box>
                  <Box>
                    <TextField
                      fullWidth
                      label="Home Port"
                      value={form.homePort}
                      onChange={(e) =>
                        setForm({ ...form, homePort: e.target.value })
                      }
                      size="small"
                    />
                  </Box>
                  <Box>
                    <TextField
                      fullWidth
                      label="LOA"
                      value={form.loa}
                      onChange={(e) =>
                        setForm({ ...form, loa: e.target.value })
                      }
                      size="small"
                    />
                  </Box>
                  <Box>
                    <FormControl fullWidth>
                      <InputLabel size="small">Currency</InputLabel>
                      <Select
                        value={
                          form.currency && currencies.includes(form.currency)
                            ? form.currency
                            : "Other"
                        }
                        label="Currency"
                        onChange={(e) => {
                          const value = e.target.value as string;
                          if (value === "Other") {
                            setShowOtherCurrencyField(true);
                            setForm({ ...form, currency: "" }); // Clear currency if 'Other' is selected
                          } else {
                            setShowOtherCurrencyField(false);
                            setForm({ ...form, currency: value });
                          }
                        }}
                        size="small"
                      >
                        <MenuItem value="">None</MenuItem>
                        {currencies.map((curr) => (
                          <MenuItem key={curr} value={curr}>
                            {curr}
                          </MenuItem>
                        ))}
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  {showOtherCurrencyField && (
                    <Box>
                      <TextField
                        fullWidth
                        label="Specify Other Currency"
                        value={form.currency} // Use form.currency directly here
                        onChange={(e) =>
                          setForm({ ...form, currency: e.target.value })
                        }
                        size="small"
                      />
                    </Box>
                  )}
                  <Box>
                    <TextField
                      fullWidth
                      label="Max Budget"
                      value={form.maxBudget}
                      onChange={(e) =>
                        setForm({ ...form, maxBudget: Number(e.target.value) })
                      }
                      type="number"
                      size="small"
                    />
                  </Box>
                  <Box>
                    <FormControl fullWidth>
                      <InputLabel size="small">Cruising Lifestyle</InputLabel>
                      <Select
                        value={form.cruisingLifestyle}
                        label="Cruising Lifestyle"
                        onChange={(e) =>
                          setForm({
                            ...form,
                            cruisingLifestyle: e.target.value,
                          })
                        }
                        size="small"
                      >
                        <MenuItem value="">None</MenuItem>
                        {cruisingLifestyles.map((style) => (
                          <MenuItem key={style} value={style}>
                            {style}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box>
                    <TextField
                      label="Address"
                      value={form.address}
                      onChange={(e) =>
                        setForm({ ...form, address: e.target.value })
                      }
                      size="small"
                      fullWidth
                    />
                  </Box>
                  <Box>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel size="small">Type</InputLabel>
                      <Select
                        value={form.type || "non assigné"}
                        label="Type"
                        onChange={(e) =>
                          setForm({ ...form, type: e.target.value })
                        }
                        size="small"
                        fullWidth
                        required
                        error={!!errors.type}
                      >
                        {prospectTypes.map((type) => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    {" "}
                    {/* Ajout du champ Comment dans le formulaire */}
                    <TextField
                      fullWidth
                      label="Comment"
                      value={form.comment}
                      onChange={(e) =>
                        setForm({ ...form, comment: e.target.value })
                      }
                      size="small"
                      multiline
                      rows={3}
                    />
                  </Box>
                </Box>
                {/* Single upload/capture zone */}
                <Typography variant="subtitle2" fontWeight={600} mb={1}>
                  Upload or Capture Photo (Max 10)
                </Typography>
                <Box
                  onDragOver={(e) => {
                    e.preventDefault();
                    setDragOver(true);
                  }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={handleDrop}
                  border={dragOver ? "2px dashed #C4B08C" : "2px dashed #ccc"}
                  borderRadius={2}
                  p={3}
                  textAlign="center"
                  bgcolor={dragOver ? "rgba(196,176,140,.08)" : "#fafafa"}
                  sx={{ cursor: "pointer", mb: 2 }}
                >
                  <CloudUpload
                    sx={{ color: "#C4B08C", mb: 1, fontSize: 32 }}
                  />
                  <Typography variant="body2" color="textSecondary">
                    Drag & drop images here or use the buttons below
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="center"
                    gap={2}
                    mt={2}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CameraAlt />}
                      sx={{ color: "#C4B08C", borderColor: "#C4B08C" }}
                      onClick={handleCameraCaptureClick}
                      disabled={imageFiles.filter(f => f !== null).length + form.images.length >= 10}
                    >
                      Take Photo
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<CloudUpload />}
                      sx={{ color: "#C4B08C", borderColor: "#C4B08C" }}
                      onClick={handleImageUploadClick}
                      disabled={imageFiles.filter(f => f !== null).length + (form.images?.length || 0) >= 10}
                    >
                      Choose from device
                    </Button>
                  </Box>
                </Box>

                {/* Preview list below */}
                {((form.images?.length || 0) > 0 || imageFiles.some(f => f !== null)) && (
                  <Box>
                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                      Selected Images ({(form.images?.length || 0) + imageFiles.filter(f => f !== null).length}/10)
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                      {/* Existing server images */}
                      {Array.isArray(form.images) && form.images.map((img, idx) => (
                        <Box key={`existing-${idx}`} sx={{ position: "relative", width: 80, height: 80 }}>
                          <Box
                            component="img"
                            src={IMAGE_URL + "/prospects/" + img}
                            sx={{ width: "100%", height: "100%", borderRadius: 1, objectFit: "cover" }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => removeImage(idx, true)}
                            sx={{ position: "absolute", top: -8, right: -8, bgcolor: "rgba(211,47,47,0.9)", color: "white", "&:hover": { bgcolor: "#d32f2f" } }}
                          >
                            <Clear sx={{ fontSize: 14 }} />
                          </IconButton>
                        </Box>
                      ))}
                      {/* New local uploads */}
                      {imageFiles.map((file, idx) => file && (
                        <Box key={`new-${idx}`} sx={{ position: "relative", width: 80, height: 80 }}>
                          <Box
                            component="img"
                            src={URL.createObjectURL(file)}
                            sx={{ width: "100%", height: "100%", borderRadius: 1, objectFit: "cover" }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => removeImage(idx, false)}
                            sx={{ position: "absolute", top: -8, right: -8, bgcolor: "rgba(211,47,47,0.9)", color: "white", "&:hover": { bgcolor: "#d32f2f" } }}
                          >
                            <Clear sx={{ fontSize: 14 }} />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}

                {isCameraActive && (
                  <Dialog open onClose={cancelPhoto} maxWidth="xs" fullWidth>
                    <DialogTitle>Capture Photo</DialogTitle>
                    <DialogContent>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/png"
                        videoConstraints={{ facingMode }}
                        style={{
                          width: "100%",
                          borderRadius: 8,
                          transform: facingMode === "user" ? "scaleX(-1)" : "none",
                        }}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setFacingMode(prev => prev === "user" ? "environment" : "user")}>
                        Switch Camera
                      </Button>
                      <Button onClick={cancelPhoto}>Cancel</Button>
                      <Button onClick={takePhoto} variant="contained" color="primary">
                        Capture
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}

                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={closeModal} sx={{ color: "#111" }}>
              Cancel
            </Button>
            {modalType !== "view" && (
              <Button
                variant="contained"
                onClick={saveProspect}
                sx={{
                  bgcolor: "#C4B08C",
                  color: "#000",
                  "&:hover": { bgcolor: "#b39d77" },
                }}
              >
                Save
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
      {/* ---------- DELETE CONFIRMATION DIALOG ---------- */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={(event, reason) => {
          // Only close when the X button is clicked
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setIsDeleteDialogOpen(false);
          }
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the prospect{" "}
            <Typography component="span" fontWeight="bold">
              {form.firstName} {form.lastName}
            </Typography>
            ?
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setIsDeleteDialogOpen(false)}>Cancel</Button>
          <Button
            color="error"
            variant="contained"
            onClick={async () => {
              if (selectedId) {
                await deleteProspect(selectedId);
                setIsDeleteDialogOpen(false);
              }
            }}
            startIcon={<Delete />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {/* ---------- WISHLISTS DIALOG ---------- */}
      <Dialog
        open={isWishlistsDialogOpen}
        onClose={(event, reason) => {
          // Only close when the X button is clicked
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setIsWishlistsDialogOpen(false);
          }
        }}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        PaperProps={{ sx: { borderRadius: isMobile ? 0 : 2 } }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#f8f5f0",
            py: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Wishlist Details
          </Typography>
          <IconButton
            onClick={() => setIsWishlistsDialogOpen(false)}
            size="small"
          >
            <Clear />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ py: 3 }}>
          {selectedProspectWishlists.length > 0 ? (
            <Box
              sx={{
                display: "grid",
                gap: 3,
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                },
              }}
            >
              {selectedProspectWishlists.map((wishlist) => (
                <Paper
                  key={wishlist.id}
                  elevation={1}
                  sx={{ p: 2, borderRadius: 2 }}
                >
                  <Box sx={{ mb: 1, pb: 1, borderBottom: "1px solid #ddd" }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                    >
                      Wishlist #{wishlist.id}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Date: {new Date(wishlist.date).toLocaleDateString()}
                    </Typography>
                  </Box>
                  <Box display="flex" flexDirection="column" gap={1}>
                    {wishlist.configuration.modeleName && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <DirectionsBoat color="action" />
                        <Typography variant="body2">
                          <strong>Model:</strong>{" "}
                          {wishlist.configuration.modeleName}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.engineName && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <SettingsSuggest color="action" />
                        <Typography variant="body2">
                          <strong>Engine:</strong>{" "}
                          {wishlist.configuration.engineName}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.propeller && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <RotateRight color="action" />
                        <Typography variant="body2">
                          <strong>Propeller:</strong>{" "}
                          {wishlist.configuration.propeller.diameter} -{" "}
                          {wishlist.configuration.propeller.angle}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.mark && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <LabelImportant color="action" />
                        <Typography variant="body2">
                          <strong>Mark:</strong> {wishlist.configuration.mark}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.propulsion && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Sailing color="action" />
                        <Typography variant="body2">
                          <strong>Propulsion:</strong>{" "}
                          {wishlist.configuration.propulsion}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.recommendedMaxSpeed && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Speed color="action" />
                        <Typography variant="body2">
                          <strong>Recommended Max Speed:</strong>{" "}
                          {wishlist.configuration.recommendedMaxSpeed}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.recommendedCruiseSpeed && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Speed color="action" />
                        <Typography variant="body2">
                          <strong>Recommended Cruise Speed:</strong>{" "}
                          {wishlist.configuration.recommendedCruiseSpeed}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.clientDesiredMinMaxSpeed && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <TrendingUp color="action" />
                        <Typography variant="body2">
                          <strong>Client Desired Min/Max Speed:</strong>{" "}
                          {wishlist.configuration.clientDesiredMinMaxSpeed} -{" "}
                          {wishlist.configuration.clientDesiredMaxMaxSpeed}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.clientDesiredMinCruiseSpeed && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <TrendingUp color="action" />
                        <Typography variant="body2">
                          <strong>Client Desired Min/Cruise Speed:</strong>{" "}
                          {wishlist.configuration.clientDesiredMinCruiseSpeed} -{" "}
                          {wishlist.configuration.clientDesiredMaxCruiseSpeed}
                        </Typography>
                      </Box>
                    )}
                    {wishlist.configuration.optionNames &&
                      wishlist.configuration.optionNames !== "[]" &&
                      (() => {
                        try {
                          const optionNamesArray = JSON.parse(
                            wishlist.configuration.optionNames,
                          );
                          return (
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={1}
                              flexWrap="wrap"
                            >
                              <Category color="action" />
                              <Typography variant="body2" mr={1}>
                                <strong>Options:</strong>
                              </Typography>
                              <Box>
                                {optionNamesArray.map((option: string) => (
                                  <Chip
                                    key={option}
                                    label={option}
                                    size="small"
                                    sx={{ mr: 0.5, mb: 0.5 }}
                                  />
                                ))}
                              </Box>
                            </Box>
                          );
                        } catch (e) {
                          console.error("Failed to parse optionNames:", e);
                          return null;
                        }
                      })()}
                  </Box>
                  {wishlist.configuration.note && (
                    <Box display="flex" alignItems="center" gap={1} mb={2}>
                      <Note color="action" />
                      <Typography variant="body2">
                        <strong>Note:</strong> {wishlist.configuration.note}
                      </Typography>
                    </Box>
                  )}
                  {/* Bouton Edit déplacé dans la carte */}
                  <Button
                    variant="contained"
                    startIcon={<Edit />}
                    fullWidth
                    onClick={() => {
                      setIsWishlistsDialogOpen(false);
                      // Naviguer vers la page de wishlist avec l'ID de la wishlist
                      window.location.href = `/wishlist?wishlistId=${encodeURIComponent(
                        wishlist.id,
                      )}`;
                    }}
                    sx={{
                      mt: 1,
                      bgcolor: "#C4B08C",
                      color: "#000",
                      "&:hover": { bgcolor: "#b39d77" },
                    }}
                  >
                    Edit in Wishlist
                  </Button>
                </Paper>
              ))}
            </Box>
          ) : (
            <Typography
              variant="body1"
              color="text.secondary"
              textAlign="center"
            >
              This prospect has no wishlists.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setIsWishlistsDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
export default ProspectsPage;
